import type { ApiGenericResponse, Service } from '../../typings'

export type ServiceFilters = {
  category_id?: string
  category_slug?: string
  provider_id?: string
  service_type_id?: string
  is_featured?: boolean | number
  name?: string
  slug?: string
}

export type ServiceQuery = {
  filters?: ServiceFilters
  sort?: string
  page?: number
  per_page?: number
}

export function getServicesAction<T = ApiGenericResponse<Service[]>>(query?: ServiceQuery): Promise<T> {
  const { api } = useApi()
  return api.get<T>('/v2/services', {
    query: {
      ...(query?.filters?.category_id !== undefined && {
        'filter[category_id]': query.filters.category_id,
      }),

      ...(query?.filters?.category_slug !== undefined && {
        'filter[category_slug]': query.filters.category_slug,
      }),

      ...(query?.filters?.provider_id !== undefined && {
        'filter[provider_id]': query.filters.provider_id,
      }),

      ...(query?.filters?.service_type_id !== undefined && {
        'filter[service_type_id]': query.filters.service_type_id,
      }),

      ...(query?.filters?.is_featured !== undefined && {
        'filter[is_featured]': query.filters.is_featured,
      }),

      ...(query?.filters?.name !== undefined && {
        'filter[name]': query.filters.name,
      }),

      ...(query?.filters?.slug !== undefined && {
        'filter[slug]': query.filters.slug,
      }),

      ...(query?.sort !== undefined && {
        sort: query.sort,
      }),

      ...(query?.page !== undefined && {
        page: query.page,
      }),

      ...(query?.per_page !== undefined && {
        per_page: query.per_page,
      }),
    },
  })
}
